import { jsxs as o, jsx as C } from "react/jsx-runtime";
import r from "./icon.js";
const d = (l) => /* @__PURE__ */ o(r, { ...l, children: [
  /* @__PURE__ */ C(
    "path",
    {
      d: "M13.2992 7.50215C13.2992 8.22012 12.7172 8.80215 11.9992 8.80215C11.2812 8.80215 10.6992 8.22012 10.6992 7.50215C10.6992 6.78418 11.2812 6.20215 11.9992 6.20215C12.7172 6.20215 13.2992 6.78418 13.2992 7.50215Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ C(
    "path",
    {
      d: "M11.7988 10.1978C11.2465 10.1978 10.7988 10.6455 10.7988 11.1978V16.7978C10.7988 17.35 11.2465 17.7978 11.7988 17.7978H12.1988C12.7511 17.7978 13.1988 17.35 13.1988 16.7978V11.1978C13.1988 10.6455 12.7511 10.1978 12.1988 10.1978H11.7988Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ C(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3Z",
      fill: "currentColor"
    }
  )
] });
export {
  d as CircleInfo,
  d as default
};
